import { render, staticRenderFns } from "./detail-old.vue?vue&type=template&id=1743f1e1&scoped=true"
import script from "./detail-old.vue?vue&type=script&lang=js"
export * from "./detail-old.vue?vue&type=script&lang=js"
import style0 from "./detail-old.vue?vue&type=style&index=0&id=1743f1e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1743f1e1",
  null
  
)

export default component.exports